<body id="scrollarea-invalid" class="outbound-scan-gle">
  <div class="outbound-scan-gle-container">
    <h3 class="page-title">Outbound Scan GLE</h3>
    <ion-row>
      <!-- Icons -->
      <ion-col class="top-icons ion-no-padding action-btn-column">
        <app-filter-icon
          [isDisabled]="!isFilterEnabled"
          (clearFilterEvent)="clearAllFilters()"
        >
        </app-filter-icon>
        <app-excel-icon (exportExcelEvent)="exportExcel()"></app-excel-icon>
        <app-new-item-icon
          [buttonText]="CONST.NEW_ULD"
          (addItem)="addNewUldModal()"
        ></app-new-item-icon>
      </ion-col>
    </ion-row>
    <!-- Table -->
    <div class="outbound-scan-gle-table-container">
      <table
        mat-table
        [dataSource]="dataSource"
        matSort
        id="excel-table"
        multiTemplateDataRows
        class="outbound-scan-gle-table"
      >
        <caption>
          OutBound Scan GLE
        </caption>

        <!-- EQUIPMENT_NUMBER -->
        <ng-container matColumnDef="equipmentNumber">
          <th mat-header-cell *matHeaderCellDef id="equipment-number-headers">
            <app-table-search-component
              [columnName]="COLUMNTEXT.EQUIPMENT_NUMBER"
              [control]="equipmentNumberData.formControl"
              [maxLength]="12"
              [textInputWidth]="130"
              (emitSearch)="search()"
            ></app-table-search-component>
          </th>
          <td
            mat-cell
            *matCellDef="let equipment; let i = index"
            headers="equipment-number-headers"
            class="equipment-number"
          >
            <a
              class="open-outbound-scan-link"
              (click)="openOutboundPopup(equipment, false)"
            >
              {{ equipment.equipmentNumber }}
            </a>
            <!-- </div>
        </ng-container> -->
          </td>
        </ng-container>

        <!-- EQUIPMENT_TYPE -->
        <ng-container matColumnDef="equipmentType">
          <th
            mat-header-cell
            *matHeaderCellDef
            id="equipment-type-headers"
            class="equipment-column-header"
          >
            <app-table-header-dropdown
              [columnText]="COLUMNTEXT.EQUIPMENT_TYPE"
              [itemId]="equipmentTypeData.itemId"
              [searchResults]="equipmentTypeOption"
              [resetData]="resetSelectDropdowns"
              [showDropdown]="dropdownOpen[1]"
              (dropdownChange)="
                dropdownOpen = commonUtils.updateDropdown(dropdownOpen, 1)
              "
              (checkboxesUpdated)="
                onStatusChangeForDropdowns($event, equipmentTypeData)
              "
            >
            </app-table-header-dropdown>
          </th>

          <td
            headers="equipment-type-headers"
            class="selectable cursor-pointer equipment-number"
            mat-cell
            *matCellDef="let outboundScan; let i = index"
          >
            {{ outboundScan.equipmentType }}
          </td>
        </ng-container>

        <!-- SEAL_NUMBER -->
        <ng-container matColumnDef="sealNumber">
          <th mat-header-cell *matHeaderCellDef id="seal-number-headers">
            <app-table-search-component
              [columnName]="COLUMNTEXT.SEAL_NUMBER"
              [control]="sealNumberData.formControl"
              [maxLength]="12"
              [textInputWidth]="130"
              (emitSearch)="search()"
            ></app-table-search-component>
          </th>

          <td
            headers="seal-number-headers"
            class="selectable cursor-pointer"
            mat-cell
            *matCellDef="let outboundScan; let i = index"
          >
            {{ outboundScan.sealNumber }}
          </td>
        </ng-container>

        <!-- CREATE_SORT_DATE -->
        <ng-container matColumnDef="createSortDate">
          <th mat-header-cell *matHeaderCellDef id="createSortDate-headers">
            <ion-row class="th-text">{{ COLUMNTEXT.CREATE_SORT_DATE }}</ion-row>
            <div class="date-picker-container sort-date-picker-container">
              <app-form-date-picker
                [icon]="SRC.CALENDAR"
                [formControl]="createSortData.formControl"
                [minDate]="minDate"
                [maxDate]="maxDate"
                (valueChange)="search()"
                [placeholder]="CONST.SELECT_DATE"
              ></app-form-date-picker>
            </div>
          </th>

          <td
            headers="createSortDate-headers"
            class="selectable cursor-pointer"
            mat-cell
            *matCellDef="let outboundScan; let i = index"
          >
            {{ outboundScan.createSortDate | date: "mediumDate" }}
          </td>
        </ng-container>

        <!-- SORT -->
        <ng-container matColumnDef="sort">
          <th
            mat-header-cell
            *matHeaderCellDef
            id="sort-headers"
            class="sort-header-container"
          >
            <app-table-header-dropdown
              [columnText]="COLUMNTEXT.SORT"
              [itemId]="sortData.itemId"
              [searchResults]="sortOption"
              [resetData]="resetSelectDropdowns"
              [showDropdown]="dropdownOpen[2]"
              (dropdownChange)="
                dropdownOpen = commonUtils.updateDropdown(dropdownOpen, 2)
              "
              (checkboxesUpdated)="onStatusChangeForDropdowns($event, sortData)"
              [popoverStyle]="{ maxWidth: 150, offsetX: -65 }"
            >
            </app-table-header-dropdown>
          </th>

          <td
            headers="sort-headers"
            class="selectable cursor-pointer sort-type"
            mat-cell
            *matCellDef="let outboundScan; let i = index"
          >
            {{ outboundScan.sort }}
          </td>
        </ng-container>

        <!-- LOAD_NAME -->
        <ng-container matColumnDef="loadName">
          <th mat-header-cell *matHeaderCellDef id="load-name-headers">
            <app-table-search-component
              [columnName]="COLUMNTEXT.LOAD_NAME"
              [control]="loadNameData.formControl"
              [maxLength]="10"
              [textInputWidth]="130"
              (emitSearch)="search()"
            ></app-table-search-component>
          </th>

          <td
            headers="load-name-headers"
            class="selectable cursor-pointer"
            mat-cell
            *matCellDef="let outboundScan; let i = index"
          >
            {{ outboundScan.loadName }}
          </td>
        </ng-container>

        <!-- LOAD_CHART -->
        <ng-container matColumnDef="loadChart">
          <th mat-header-cell *matHeaderCellDef id="load-chart-headers">
            <app-table-search-component
              [columnName]="COLUMNTEXT.LOAD_CHART"
              [control]="loadChartData.formControl"
              [maxLength]="10"
              [textInputWidth]="130"
              (emitSearch)="search()"
            ></app-table-search-component>
          </th>

          <td
            headers="load-chart-headers"
            class="selectable cursor-pointer"
            mat-cell
            *matCellDef="let outboundScan; let i = index"
          >
            {{ outboundScan.loadChart }}
          </td>
        </ng-container>

        <!-- MOVEMENT -->
        <ng-container matColumnDef="movement">
          <th mat-header-cell *matHeaderCellDef id="parent-uld-headers">
            <app-table-search-component
              [columnName]="COLUMNTEXT.MOVEMENT"
              [control]="movementData.formControl"
              [maxLength]="10"
              [textInputWidth]="130"
              (emitSearch)="search()"
            ></app-table-search-component>
          </th>

          <td
            headers="parent-uld-headers"
            class="selectable cursor-pointer"
            mat-cell
            *matCellDef="let outboundScan; let i = index"
          >
            {{ outboundScan.movement }}
          </td>
        </ng-container>

        <!-- PARENT_ULD -->
        <ng-container matColumnDef="parentUld">
          <th mat-header-cell *matHeaderCellDef id="movement-headers">
            <app-table-search-component
              [columnName]="COLUMNTEXT.PARENT_ULD"
              [control]="parentUldData.formControl"
              [maxLength]="10"
              [textInputWidth]="130"
              (emitSearch)="search()"
            ></app-table-search-component>
          </th>

          <td
            headers="movement-headers"
            class="selectable cursor-pointer"
            mat-cell
            *matCellDef="let outboundScan; let i = index"
          >
            {{ outboundScan.parentUld }}
          </td>
        </ng-container>

        <!-- TYPE -->
        <ng-container matColumnDef="type">
          <th
            mat-header-cell
            *matHeaderCellDef
            id="type-headers"
            class="type-container"
          >
            <app-table-header-dropdown
              [columnText]="COLUMNTEXT.TYPE"
              [itemId]="typeData.itemId"
              [searchResults]="typeOption"
              [resetData]="resetSelectDropdowns"
              [showDropdown]="dropdownOpen[3]"
              (dropdownChange)="
                dropdownOpen = commonUtils.updateDropdown(dropdownOpen, 3)
              "
              (checkboxesUpdated)="onStatusChangeForDropdowns($event, typeData)"
              [popoverStyle]="{ maxWidth: 100, offsetX: -65 }"
            >
            </app-table-header-dropdown>
          </th>

          <td
            headers="type-headers"
            class="selectable cursor-pointer type"
            mat-cell
            *matCellDef="let outboundScan; let i = index"
          >
            {{ outboundScan.type }}
          </td>
        </ng-container>

        <!-- Action -->
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef id="action-headers">
            <ion-row class="th-text"> {{ COLUMNTEXT.ACTION }} </ion-row>
            <div class="empty-item"></div>
          </th>
          <td
            mat-cell
            *matCellDef="let admin; let i = index"
            headers="action-headers"
          >
            @let isDomestic =
              admin?.rawUlo?.loadKey?.discriminator === "DOMESTIC";
            <div
              class="action-btns"
              [ngClass]="{
                'ion-justify-content-end': !isDomestic,
              }"
            >
              @if (isDomestic) {
                <button
                  class="button-for-icons action-move-icon"
                  (click)="openTransferUldModal(admin)"
                >
                  <ion-icon
                    [src]="SRC.MOVE_DOWN"
                    class="action-move-icon"
                  ></ion-icon>
                </button>
              }
              <button
                class="button-for-icons action-delete-icon"
                (click)="closeUld(admin, i)"
              >
                <img alt="cancel" [src]="SRC.CANCEL" />
              </button>
            </div>
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns; let i = dataIndex"
          [ngClass]="{ 'alt-row': 0 !== i % 2 }"
        ></tr>

        <tr class="mat-row" *matNoDataRow>
          <td
            class="mat-cell no-border no-results"
            [attr.colspan]="displayedColumns.length"
          >
            <app-no-results-found></app-no-results-found>
          </td>
        </tr>
      </table>
    </div>
  </div>
  <app-table-pagination [datasource]="dataSource"></app-table-pagination>
</body>
